// Authentication utilities
import { api, User } from './api';

export type { User };

function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message?: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message;
  }
  return fallback;
}

export const login = async (email: string, password: string): Promise<User> => {
  try {
    const user = await api.login(email, password);
    if (typeof window !== 'undefined') {
      localStorage.setItem('user', JSON.stringify(user));
    }
    return user;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Invalid credentials'));
  }
};

export const register = async (email: string, password: string, name?: string): Promise<User> => {
  try {
    const user = await api.register(email, password, name);
    if (typeof window !== 'undefined') {
      localStorage.setItem('user', JSON.stringify(user));
    }
    return user;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Registration failed'));
  }
};

export const logout = async () => {
  try {
    await api.logout();
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  }
};

export const getCurrentUser = (): User | null => {
  if (typeof window === 'undefined') return null;
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAuthenticated = (): boolean => {
  return getCurrentUser() !== null;
};
